export default __webpack_public_path__ + "static/media/Foot_left.430b24a6.svg";